import { getLocalTimeZone } from '@internationalized/date';
import { createContext, useContext } from 'react';

export const TimeZoneContext = createContext(getLocalTimeZone());

export const useTimeZone = (): string => useContext(TimeZoneContext);
